import { useCallback, useEffect, useState } from "react";

export type Theme = "dark" | "light";
const KEY = "vocaler-theme";

function read(): Theme {
  const params = new URLSearchParams(window.location.search);
  const requested = params.get("theme");
  if (requested === "light" || requested === "dark") return requested;
  const stored = localStorage.getItem(KEY);
  return stored === "light" ? "light" : "dark";
}

function apply(theme: Theme) {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem(KEY, theme);
}

/** Theme controller. Ported from project/theme.js: dark is the default,
    light is a variant. Persists to localStorage; honours ?theme= override. */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() =>
    typeof window === "undefined" ? "dark" : read(),
  );

  useEffect(() => {
    apply(theme);
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "light" ? "dark" : "light")), []);
  const set = useCallback((t: Theme) => setTheme(t), []);

  return { theme, toggle, set };
}
